import React from "react";

const ShowEnvironmentComponent = () => {
  let env = process.env.REACT_APP_ENVIRONMENT;
  if (env === "TEST") {
    return <div className="text-danger text-extra-bold">Admin Web TEST</div>;
  }else{
  }
  return <div className="text-extra-bold">Admin Web</div>;
};

export default ShowEnvironmentComponent;
